import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function EncounterComplicationIndex() {
  return (
    <NonFSIndex
      data_type="encounter_complication"
    />
  );
}
